import React from 'react';
import config from '../../../../config';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import * as Yup from 'yup';
import { Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';

const Product = () => {
  const urls = {
    list: config.PRODUCT,
    create: config.PRODUCT
  };
  const resource = 'PRODUCT';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'productId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: t('type'),
      name: 'productType',
      type: 'select',
      required: true,
      isEditable: true,
      validationSchema: Yup.object().nullable().required('Product type is required'),
      options: {
        url: config.PRODUCT_TYPE,
        name: 'productType',
        uniqueId: 'productTypeId',
        requestField: 'productTypeId',
        render: (option) => `${option.productTypeName} | ${option.productTypeId}`
      },
      render: ({ value }) => value && value.productTypeName
    },
    {
      header: t('name'),
      name: 'name',
      type: 'string',
      required: true,
      isEditable: true,
      validationSchema: Yup.string().max(255).required('Name is required'),
      defaultFlex: 1
    },
    {
      header: t('description'),
      name: 'description',
      type: 'string',
      isEditable: true,
      excludeInFilter: true,
      validationSchema: Yup.string().max(255)
    },
    {
      header: t('external.id'),
      name: 'externalId',
      type: 'number',
      isEditable: true,
      excludeInFilter: true,
      filterEditor: NumberFilter
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      excludeInFilter: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      excludeInFilter: true,
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('date.modified'),
      name: 'dateModified',
      type: 'date',
      excludeInFilter: true,
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('products')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'productId'}
        tableId={'product'}
        columns={columns}
        urls={urls}
        disableUpdate={true}
        disableDelete={true}
      />
      <NavBar />
    </>
  );
};

export default Product;
